import styled from 'styled-components';

export const Container = styled.form`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 1rem;
  border-top: 1px solid ${({ theme }) => theme.colors?.gray02};
  background-color: ${({ theme }) => theme.colors?.backgroundColor};
`;

export const Input = styled.textarea`
  flex: 1;
  padding: 0.75rem;
  border: 1px solid ${({ theme }) => theme.colors?.gray02};
  border-radius: 8px;
  resize: none;
  font-size: ${({ theme }) => theme.fontSize?.[theme.fontSizeType]?.fs12};
  font-family: inherit;
  min-height: 40px;
  max-height: 120px;
  color: ${({ theme }) => theme.colors?.text?.primary};
  background-color: ${({ theme }) => theme.colors?.backgroundColor};

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.colors?.primary};
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const SendButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border: none;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors?.primary};
  color: ${({ theme }) => theme.colors?.white01};
  cursor: pointer;
  transition: opacity 0.2s;

  &:hover:not(:disabled) {
    opacity: 0.9;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

